import { backgroundImageDirective, clickOutsideDirective } from "@wittignl/js-core";
import { spinnerDirective } from "@wittignl/js-ui";

export default function(app){

    app.directive('background-image', backgroundImageDirective);
    app.directive('click-outside', clickOutsideDirective);
    //app.directive('spinner', spinnerDirective);
}